import moment from "moment";

export interface IJob {
  created_date?: Date;
  modified_date?: Date;
  name?: string;
  assigned_to?: any;
  due_date?: any;
  status?: number;
  description?: string;
  urgent?: boolean;
  target_start_date?: any;
  actual_start_date?: Date | moment.Moment;
  actual_completion_date?: Date | moment.Moment;
  created_by?: Object | number;
  completed_by?: Object | number;
  completed_date?: Date;
  recurring?: boolean;
  recurrence_options?: Object;
  uuid?: string;
  client_company?: any;
  accounting_company?: Object | number;
  task_groups?: Array<TaskGroup>;
  task_groups_preload?: Array<TaskGroupPreload>;
  autopilot_publish_date?: Date | moment.Moment;
  message_count: number;
  is_template?: boolean;
  is_master_template?: boolean;
  starting_owner?: Object | number;
  tags: Array<any>;
  files: Array<File>;
  related_thread?: Object;
  files_count?: number;
  autopilot_days?: number;
  current_group?: string;
}

export class Job implements IJob {
  constructor({
    created_date = new Date(),
    modified_date = new Date(),
    name = "",
    assigned_to = null,
    due_date = moment(new Date(), "MM-DD-YYYY"),
    status = 0,
    description = "",
    urgent = false,
    target_start_date = moment(new Date(), "MM-DD-YYYY"),
    actual_start_date = new Date(),
    actual_completion_date = new Date(),
    created_by = null,
    completed_by = null,
    completed_date = new Date(),
    recurring = false,
    recurrence_options = {
      adjust_start_date: 0,
      weekly_weeks: 0,
      monthly_day: 0,
    },
    uuid = Math.random()
      .toString(36)
      .replace(/[^a-z]+/g, "")
      .substr(0, 5),
    client_company = null,
    accounting_company = null,
    task_groups = [],
    autopilot_publish_date = null,
    message_count = 0,
    is_template = false,
    is_master_template = false,
    starting_owner = {},
    tags = [],
    related_thread = null,
    pinned_item = null,
    files_count = null,
    autopilot_days = 1,
    current_group = null,
    task_groups_preload = [],
  }: {
    created_date?: Date;
    modified_date?: Date;
    name?: string;
    assigned_to?: any;
    due_date?: any;
    status?: number;
    description?: string;
    urgent?: boolean;
    target_start_date?: Date | any;
    actual_start_date?: Date | any;
    actual_completion_date?: any;
    created_by?: Object | number;
    completed_by?: Object | number;
    completed_date?: Date;
    recurring?: boolean;
    recurrence_options?: Object;
    uuid?: string | null;
    client_company?: any;
    accounting_company?: Object | number;
    task_groups?: Array<TaskGroup>;
    autopilot_publish_date?: Date | any;
    message_count?: number;
    is_template?: boolean;
    is_master_template?: boolean;
    starting_owner?: Object | number;
    tags?: Array<any>;
    related_thread?: Object;
    pinned_item?: Object;
    files_count?: number;
    autopilot_days?: number;
    current_group?: string;
    task_groups_preload?: Array<TaskGroupPreload>;
  } = {}) {
    this.created_date = created_date;
    this.modified_date = modified_date;
    this.name = name;
    this.assigned_to = assigned_to;
    this.due_date = due_date;
    this.status = status;
    this.description = description;
    this.urgent = urgent;
    this.target_start_date = target_start_date;
    this.actual_start_date = actual_start_date;
    this.actual_completion_date = actual_completion_date;
    this.created_by = created_by;
    this.completed_by = completed_by;
    this.completed_date = completed_date;
    this.recurring = recurring;
    this.recurrence_options = recurrence_options;
    this.uuid = uuid;
    this.client_company = client_company;
    this.accounting_company = accounting_company;
    this.task_groups = task_groups;
    this.task_groups_preload = task_groups_preload;
    this.autopilot_publish_date = autopilot_publish_date;
    this.message_count = message_count;
    this.is_template = is_template;
    this.is_master_template = is_master_template;
    this.starting_owner = this.starting_owner;
    this.tags = this.tags;
    this.files = this.files;
    this.related_thread = this.related_thread;
    this.pinned_item = pinned_item;
    this.files_count = this.files_count;
    this.autopilot_days = autopilot_days;
    this.current_group = current_group;
  }

  created_date: Date = new Date();
  modified_date: Date = new Date();
  name: string;
  assigned_to: any;
  due_date: any = new Date();
  status: number;
  description: string;
  urgent: boolean;
  target_start_date: any = new Date();
  actual_start_date: Date;
  actual_completion_date: Date;
  created_by: Object | number;
  completed_by: Object | number;
  completed_date: Date;
  recurring: boolean;
  recurrence_options: Object;
  uuid: string | null;
  client_company: any;
  accounting_company: Object | number;
  task_groups: Array<TaskGroup>;
  task_groups_preload: Array<TaskGroupPreload>;
  autopilot_publish_date?: Date;
  message_count: number;
  is_template: boolean;
  is_master_template: boolean;
  starting_owner: Object | number;
  tags: Array<any>;
  files: Array<File>;
  related_thread?: Object;
  pinned_item?: Object;
  files_count?: number;
  autopilot_days?: number;
  current_group?: string;
}

export interface ITaskGroup {
  completed?: boolean;
  completed_by?: Object | number;
  completed_date?: Date;
  created_date?: Date;
  description?: string;
  name?: String;
  id?: number;
  job?: Object | number;
  modified_date?: Date;
  order?: number;
  uuid?: string;
  tasks?: Array<Task>;
  owner?: Object | number;
  due_date?: number;
}

export interface TaskGroupPreload {
  name: string;
  due_date?: number;
  owner?: {
      id: string;
      full_name: string;
      pictureUrl: string;
  }
  completed: boolean;
}

export class TaskGroup implements ITaskGroup {
  constructor({
    completed = false,
    completed_by = null,
    completed_date = null,
    created_date = new Date(),
    description = "",
    name = "",
    id = 0,
    job = {},
    modified_date = new Date(),
    order = 0,
    uuid = Math.random()
      .toString(36)
      .replace(/[^a-z]+/g, "")
      .substr(0, 5),
    tasks = [],
    owner = {},
    saving = false,
    due_date = null,
  }: {
    completed?: boolean;
    completed_by?: Object | number;
    completed_date?: Date;
    created_date?: Date;
    description?: string;
    name?: string;
    id?: number;
    job?: Object | number;
    modified_date?: Date;
    order?: number;
    uuid?: string;
    tasks?: Array<Task>;
    owner?: Object | number;
    saving?: boolean;
    due_date?: null;
  } = {}) {
    this.completed = completed;
    this.completed_by = completed_by;
    this.completed_date = completed_date;
    this.created_date = created_date;
    this.description = description;
    this.name = name;
    this.id = id;
    this.job = job;
    this.modified_date = modified_date;
    this.order = order;
    this.uuid = uuid;
    this.tasks = tasks;
    this.owner = owner;
    this.saving = saving;
    this.due_date = due_date;
  }

  completed: boolean;
  completed_by: Object | number;
  completed_date: Date;
  created_date: Date;
  description: string;
  name: string;
  id: number;
  job: Object | number;
  modified_date: Date;
  order: number;
  uuid: string;
  tasks: Array<Task>;
  owner: Object | number;
  saving: boolean;
  due_date?: number;
}

export interface ITask {
  completed?: boolean;
  completed_by?: Object | number;
  completed_date?: Date;
  created_date?: Date;
  description?: string;
  name?: string;
  id?: number;
  task_group?: Object | number;
  modified_date?: Date;
  order?: number;
  uuid?: string;
  related_tracked_item?: string | any;
}

export interface ITrackedItem {
  uuid: string;
  answer_status: string;
}

export class Task implements ITask {
  constructor({
    completed = false,
    completed_by = null,
    completed_date = null,
    created_date = new Date(),
    description = "",
    name = "",
    id = 0,
    task_group = {},
    modified_date = new Date(),
    order = 0,
    uuid = Math.random()
      .toString(36)
      .replace(/[^a-z]+/g, "")
      .substr(0, 5),
    related_tracked_item = null,
    saving = false,
  }: {
    completed?: boolean;
    completed_by?: Object | number;
    completed_date?: Date;
    created_date?: Date;
    description?: string;
    name?: string;
    id?: number;
    task_group?: Object | number;
    modified_date?: Date;
    order?: number;
    uuid?: string;
    related_tracked_item?: ITrackedItem;
    saving?: boolean;
  } = {}) {
    this.completed = completed;
    this.completed_by = completed_by;
    this.completed_date = completed_date;
    this.created_date = created_date;
    this.description = description;
    this.name = name;
    this.id = id;
    this.task_group = task_group;
    this.modified_date = modified_date;
    this.order = order;
    this.uuid = uuid;
    this.related_tracked_item = related_tracked_item;
    this.saving = saving;
  }

  completed: boolean;
  completed_by: Object | number;
  completed_date: Date;
  created_date: Date;
  description: string;
  name: string;
  id: number;
  task_group: Object | number;
  modified_date: Date;
  order: number;
  uuid: string;
  related_tracked_item: ITrackedItem;
  saving: boolean;
}
